import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { InputBatchConfigFormat } from "pages/geoscape-batch/types";

const MappingTableInput = ({ inPutParameters }: any) => {
  inPutParameters.sort((a: any, b: any) => {
    if (a.apiParameter === "Ignore" && b.apiParameter !== "Ignore") {
      return 1;
    } else if (a.apiParameter !== "Ignore" && b.apiParameter === "Ignore") {
      return -1;
    } else {
      return 0;
    }
  });

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        {inPutParameters.map(
          (parameter: InputBatchConfigFormat, index: number) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                gap: "24px",
                justifyContent: "space-around",
                width: "100%",
                marginBottom: "16px",
                alignItems: "center",
              }}
            >
              <Card
                sx={{
                  boxShadow: "0px 0px 2px 0px",
                  display: "flex",
                  justifyContent: "center",
                  gap: "16px",
                  width: "80%",
                  padding: "8px",
                }}
              >
                <TextField
                  size="small"
                  id={`name-${index}`}
                  name="name"
                  label="Column Name"
                  type="text"
                  value={parameter.name}
                  variant="outlined"
                  sx={{ width: "50%" }}
                />
                <TextField
                  size="small"
                  id={`name-${index}`}
                  name="name"
                  label="Attribute"
                  type="text"
                  value={parameter.apiParameter}
                  variant="outlined"
                  disabled={parameter.apiParameter == "Ignore" ? true : false}
                  sx={{ width: "50%" }}
                />
              </Card>
            </Box>
          )
        )}
      </Box>
    </>
  );
};

export default MappingTableInput;
